import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SelectionListComponent } from './selection-list/selection-list.component';
import { IconModule, TooltipModule } from '@liberty-financial/ng-components';

@NgModule({
  declarations: [
    SelectionListComponent
  ],
  imports: [
    CommonModule,
    TooltipModule,
    IconModule
  ],
  exports: [
    SelectionListComponent
  ]
})
export class SelectionModule { }
